import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/newsletter/newsletter.component').then(
        m => m.NewsletterComponent,
      ),
    title: 'Newsletter',
  },
];
